import { Component } from "@angular/core";
import { SHARED } from "@apps/patient-core/src/app/shared";

@Component({
  selector: "dentr-privacy-policy-default",
  templateUrl: "./privacy-policy-default.component.html",
  standalone: true,
  imports: [SHARED],
})
export class PrivacyPolicyDefaultComponent {}
